import { getAuth } from '../helpers';

import { apiInterceptor } from 'utils/apiInterceptor';
export async function getAllDeployments({
    projectId,
    search = '',
    sortBy = 'updatedAt',
    sortOrder = 'desc',
    page = 1,
    limit = 10,
    updatedIds = [],
    createdIds = [],
    labelIds = [],
}) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth.access_token}`;
    let url = `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/list/${projectId}?sortBy=${sortBy}&sortOrder=${sortOrder}&page=${page}&limit=${limit}`;
    if (search) {
        url += `&search=${search}`;
    }
    if (updatedIds.length) {
        url += `&updatedIds=${updatedIds.join(',')}`;
    }
    if (createdIds.length) {
        url += `&createdIds=${createdIds.join(',')}`;
    }
    if (labelIds.length) {
        url += `&labelIds=${labelIds.join(',')}`;
    }
    const response = await apiInterceptor(url, {
        method: 'GET',
        headers: {
            Authorization: authBearer,
        },
    });
    return await response.json();
}

export async function getDeploymentCreators({
    projectId,
    sortBy = 'updatedBy',
    dropDownSearch = '',
    page = 1,
    limit = 10,
}) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/get-creaters/${projectId}?sortBy=${sortBy}&dropDownSearch=${dropDownSearch}&page=${page}&limit=${limit}`,
        {
            method: 'GET',
            headers: {
                Authorization: authBearer,
            },
        }
    );

    return await response.json();
}

export async function createDeployment({ projectId, payload }) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/create`,
        {
            method: 'POST',
            headers: {
                Authorization: authBearer,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ projectId, ...payload }),
        }
    );
    return await response.json();
}

export async function uploadDeploymentImage({ projectId, payload }) {
    const auth = getAuth();
    const formData = new FormData();
    for (const property in payload) {
        formData.append(property, payload[property]);
    }

    const authBearer = `Bearer ${auth.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/upload?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
                Authorization: authBearer,
            },
            body: formData,
        }
    );
    return await response.json();
}

export async function updateDeployment({ projectId, deploymentId, payload }) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth?.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/${deploymentId}?projectId=${projectId}`,
        {
            method: 'PUT',
            headers: {
                Authorization: authBearer,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ projectId, ...payload }),
        }
    );
    return await response.json();
}

export async function getDeployment({ projectId, deploymentId }) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/${deploymentId}?projectId=${projectId}`,
        {
            method: 'GET',
            headers: {
                Authorization: authBearer,
            },
        }
    );
    return await response.json();
}

export async function cloneDeployment({ projectId, deploymentId, name }) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/clone?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
                Authorization: authBearer,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: deploymentId, name }),
        }
    );
    return await response.json();
}

export async function deleteDeployment({ projectId, deploymentId }) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/${deploymentId}?projectId=${projectId}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: authBearer,
            },
        }
    );
    return await response.json();
}

export async function downloadDeploymentCertificate({
    projectId,
    deploymentId,
    format = 'pgp',
    type = 'selfServiceKiosk',
}) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/download-certificate?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
                Authorization: authBearer,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: deploymentId, format, type }),
        }
    );
    if (response?.status !== 200) throw response;
    return await response.blob();
}

export async function bulkDownloadDeploymentCertificates({
    projectId,
    deploymentIds,
    format = 'pgp',
    type = 'selfServiceKiosk',
}) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/bulk-download-certificates?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
                Authorization: authBearer,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: deploymentIds, format, type }),
        }
    );
    if (response?.status !== 200) throw response;
    return await response.blob();
}

export async function resetOrChangeDeploymentPassword({
    projectId,
    deploymentId,
    password,
}) {
    const auth = getAuth();

    const authBearer = `Bearer ${auth?.access_token}`;
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/onsite/deployments/reset-certificate-pin?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
                Authorization: authBearer,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: deploymentId, password }),
        }
    );
    return await response.json();
}
